(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Interactive USA Map Module
 * Handles click/hover interactions and popup display
 */
var USAInteractiveMap = /*#__PURE__*/function () {
  function USAInteractiveMap() {
    _classCallCheck(this, USAInteractiveMap);
    this.container = document.getElementById('hl-usa-map');
    this.popup = document.getElementById('hl-usa-map-popup');
    this.data = window.usaMapData || {};
    // Optional product subset (set via data-products on the container, e.g. EquitySelect map).
    // When set, the state popup only lists these products. null = show all products.
    var productsAttr = this.container ? this.container.dataset.products : '';
    this.allowedProducts = productsAttr ? productsAttr.split(',').map(function (p) {
      return p.trim();
    }) : null;
    this.legends = window.usaMapLegends || [];
    this.pluginUrl = window.hlMapPluginUrl || '';
    this.activeState = null;
    this.isPopupPinned = false;
    this.panZoomInstance = null;
    this.activeFilters = [];
    this.filterMode = 'and'; // 'and' or 'or'
    this.isMobile = this.detectMobile();
    this.touchStartY = 0;
    if (!this.container) {
      return;
    }
    this.init();
    this.initResponsive();
  }

  /**
   * Detect if viewport is mobile-sized.
   *
   * Returns true ONLY when the viewport width is below 768px.
   * Touch capability is intentionally NOT considered — many desktops/laptops
   * have touch screens (Surface, Yoga, XPS, etc.) but the user still expects
   * a desktop layout. Chrome DevTools in responsive mode also emulates touch
   * events, which would falsely trigger mobile mode on any developer's machine.
   */
  return _createClass(USAInteractiveMap, [{
    key: "detectMobile",
    value: function detectMobile() {
      return window.innerWidth < 768;
    }

    /**
     * Initialize responsive features
     */
  }, {
    key: "initResponsive",
    value: function initResponsive() {
      var _this = this;
      // Handle viewport resize
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          _this.handleViewportChange();
        }, 250);
      });

      // Handle orientation change
      window.addEventListener('orientationchange', function () {
        setTimeout(function () {
          _this.handleOrientationChange();
        }, 100);
      });

      // Collapse legend on mobile by default
      if (this.isMobile) {
        var legend = document.querySelector('.hl-map-legend');
        if (legend) {
          legend.classList.remove('hl-legend-expanded');
        }
      }
    }

    /**
     * Handle viewport size changes
     */
  }, {
    key: "handleViewportChange",
    value: function handleViewportChange() {
      var _this2 = this;
      var wasMobile = this.isMobile;
      this.isMobile = this.detectMobile();

      // Switch popup mode if crossed mobile/desktop boundary
      if (wasMobile !== this.isMobile && this.activeState) {
        var currentState = this.activeState;
        this.closePopup();
        setTimeout(function () {
          _this2.showPopup(currentState, _this2.isPopupPinned);
        }, 100);
      }

      // Resize pan-zoom
      if (this.panZoomInstance) {
        this.panZoomInstance.resize();
        this.panZoomInstance.fit();
        this.panZoomInstance.center();
      }
    }

    /**
     * Handle orientation changes
     */
  }, {
    key: "handleOrientationChange",
    value: function handleOrientationChange() {
      if (this.panZoomInstance) {
        this.panZoomInstance.resize();
        this.panZoomInstance.fit();
        this.panZoomInstance.center();
      }

      // Adjust popup if open
      if (this.activeState) {
        this.repositionPopup();
      }
    }

    /**
     * Reposition popup based on current mode
     */
  }, {
    key: "repositionPopup",
    value: function repositionPopup() {
      if (!this.popup || !this.activeState) return;
      if (this.isMobile) {
        this.showBottomSheet();
      }
    }

    /**
     * Show popup as bottom sheet on mobile
     */
  }, {
    key: "showBottomSheet",
    value: function showBottomSheet() {
      if (!this.popup) return;
      this.popup.classList.add('hl-popup-mobile', 'hl-popup-bottom-sheet');
      this.popup.classList.remove('hl-popup-desktop');
      this.popup.style.position = 'fixed';
      this.popup.style.bottom = '0';
      this.popup.style.left = '0';
      this.popup.style.right = '0';
      this.popup.style.top = 'auto';
      this.popup.style.transform = 'none';
      this.attachSwipeGestures();
    }

    /**
     * Attach swipe-to-dismiss gestures for mobile bottom sheet
     */
  }, {
    key: "attachSwipeGestures",
    value: function attachSwipeGestures() {
      var _this3 = this;
      if (!this.popup) return;
      var startY = 0;
      var currentY = 0;
      var isDragging = false;
      var handleTouchStart = function handleTouchStart(e) {
        startY = e.touches[0].clientY;
        isDragging = true;
        _this3.popup.style.transition = 'none';
      };
      var handleTouchMove = function handleTouchMove(e) {
        if (!isDragging) return;
        currentY = e.touches[0].clientY;
        var deltaY = currentY - startY;

        // Only allow downward dragging
        if (deltaY > 0) {
          _this3.popup.style.transform = "translateY(".concat(deltaY, "px)");
        }
      };
      var handleTouchEnd = function handleTouchEnd() {
        if (!isDragging) return;
        isDragging = false;
        var deltaY = currentY - startY;
        _this3.popup.style.transition = 'transform 0.3s ease-out';

        // Dismiss if dragged down more than 100px
        if (deltaY > 100) {
          _this3.popup.style.transform = 'translateY(100%)';
          setTimeout(function () {
            _this3.closePopup();
          }, 300);
        } else {
          // Snap back to position
          _this3.popup.style.transform = 'translateY(0)';
        }
      };

      // Remove old listeners if any
      this.popup.removeEventListener('touchstart', handleTouchStart);
      this.popup.removeEventListener('touchmove', handleTouchMove);
      this.popup.removeEventListener('touchend', handleTouchEnd);

      // Attach new listeners
      this.popup.addEventListener('touchstart', handleTouchStart, {
        passive: true
      });
      this.popup.addEventListener('touchmove', handleTouchMove, {
        passive: true
      });
      this.popup.addEventListener('touchend', handleTouchEnd, {
        passive: true
      });
    }

    /**
     * Initialize the map
     */
  }, {
    key: "init",
    value: (function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              // Add loading class
              this.container.closest('.hl-usa-map-container').classList.add('loading');
              _context.n = 1;
              return this.loadSVG();
            case 1:
              this.attachPopupEvents();
              this.initZoomControls();
              this.initSearchControls();
              this.initServiceFilters();
              this.initLegendToggle();

              // Remove loading class
              this.container.closest('.hl-usa-map-container').classList.remove('loading');
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
    /**
     * Load and inject SVG map from external file
     */
    )
  }, {
    key: "loadSVG",
    value: (function () {
      var _loadSVG = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var svgUrl, response, svgText, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              svgUrl = this.pluginUrl + 'assets/images/us.svg';
              _context2.n = 1;
              return fetch(svgUrl);
            case 1:
              response = _context2.v;
              _context2.n = 2;
              return response.text();
            case 2:
              svgText = _context2.v;
              // Inject SVG
              this.container.innerHTML = svgText;

              // Process the loaded SVG
              this.processSVGStates();
              this.applyColors();
              this.addStateLabels();
              this.addLeaderLines(); // Add leader lines for small eastern states
              this.attachStateEvents();
              this.initPanZoom();
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              console.error('Failed to load USA map SVG:', _t);
              this.container.innerHTML = '<p>Failed to load map. Please refresh the page.</p>';
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 3]]);
      }));
      function loadSVG() {
        return _loadSVG.apply(this, arguments);
      }
      return loadSVG;
    }()
    /**
     * Initialize pan-zoom functionality
     */
    )
  }, {
    key: "initPanZoom",
    value: function initPanZoom() {
      var _this4 = this;
      var svg = this.container.querySelector('svg');
      if (!svg || typeof svgPanZoom === 'undefined') {
        return;
      }

      // Extend SVG viewBox to accommodate leader lines on the right
      var viewBox = svg.viewBox.baseVal;
      var originalWidth = viewBox.width;
      var originalHeight = viewBox.height;
      var extendedWidth = originalWidth + 150; // Add space for leader lines (50px offset + 32px circle + buffer)

      // Update viewBox to include extended area
      svg.setAttribute('viewBox', "".concat(viewBox.x, " ").concat(viewBox.y, " ").concat(extendedWidth, " ").concat(originalHeight));

      // Mobile-optimized settings
      var panZoomOptions = {
        zoomEnabled: true,
        controlIconsEnabled: false,
        fit: true,
        center: true,
        contain: true,
        // Force contain mode to show entire SVG
        minZoom: 0.3,
        // Lower minZoom to allow showing full map on all devices
        maxZoom: 10,
        zoomScaleSensitivity: this.isMobile ? 0.5 : 0.3,
        // Higher sensitivity on mobile for better pinch-zoom
        dblClickZoomEnabled: this.isMobile,
        // Enable double-tap zoom on mobile
        mouseWheelZoomEnabled: false,
        // Disabled mouse wheel zoom
        preventMouseEventsDefault: this.isMobile,
        // Prevent default on mobile to avoid conflicts
        eventsListenerElement: this.isMobile ? svg : null // Better touch handling on mobile
      };
      this.panZoomInstance = svgPanZoom(svg, panZoomOptions);

      // Force fit and center after initialization with longer delay for mobile DOM rendering
      if (this.panZoomInstance) {
        setTimeout(function () {
          _this4.panZoomInstance.resize();
          _this4.panZoomInstance.fit();
          _this4.panZoomInstance.center();
        }, 300);
      }
    }

    /**
     * Initialize zoom control buttons
     */
  }, {
    key: "initZoomControls",
    value: function initZoomControls() {
      var _this5 = this;
      var container = this.container.closest('.hl-usa-map-container');
      if (!container) return;

      // Create controls HTML
      var controlsHTML = "\n\t\t\t<div class=\"hl-zoom-controls\">\n\t\t\t\t<button class=\"hl-zoom-btn\" id=\"hl-zoom-in\" aria-label=\"Zoom in\" title=\"Zoom in\">+</button>\n\t\t\t\t<button class=\"hl-zoom-btn\" id=\"hl-zoom-out\" aria-label=\"Zoom out\" title=\"Zoom out\">\u2212</button>\n\t\t\t\t<button class=\"hl-zoom-btn\" id=\"hl-zoom-reset\" aria-label=\"Reset zoom\" title=\"Reset zoom\">\u27F2</button>\n\t\t\t</div>\n\t\t";
      container.insertAdjacentHTML('beforeend', controlsHTML);

      // Attach event listeners
      document.getElementById('hl-zoom-in').addEventListener('click', function () {
        if (_this5.panZoomInstance) {
          _this5.panZoomInstance.zoomIn();
        }
      });
      document.getElementById('hl-zoom-out').addEventListener('click', function () {
        if (_this5.panZoomInstance) {
          _this5.panZoomInstance.zoomOut();
        }
      });
      document.getElementById('hl-zoom-reset').addEventListener('click', function () {
        if (_this5.panZoomInstance) {
          _this5.panZoomInstance.resetZoom();
          _this5.panZoomInstance.resetPan();
        }
      });
    }

    /**
     * Process SVG states - ensure they have proper data attributes
     */
  }, {
    key: "processSVGStates",
    value: function processSVGStates() {
      var _this6 = this;
      var svg = this.container.querySelector('svg');
      if (!svg) return;

      // Find all path elements with id or data-id attributes
      var statePaths = svg.querySelectorAll('path[id], path[data-id]');
      statePaths.forEach(function (path) {
        var stateCode = path.id || path.getAttribute('data-id');
        if (stateCode && stateCode.length === 2) {
          // Normalize to use data-state attribute
          path.setAttribute('data-state', stateCode.toUpperCase());
          path.classList.add('hl-state');

          // Add accessibility attributes
          var stateData = _this6.data[stateCode.toUpperCase()];
          if (stateData) {
            path.setAttribute('aria-label', stateData.title);
            path.setAttribute('role', 'button');
            path.setAttribute('tabindex', '0');
          }
        }
      });
    }

    /**
     * Add state code labels as SVG text elements with circle backgrounds
     */
  }, {
    key: "addStateLabels",
    value: function addStateLabels() {
      var svg = this.container.querySelector('svg');
      if (!svg) return;
      var states = svg.querySelectorAll('[data-state]');
      var labelsGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      labelsGroup.id = 'state-labels';

      // Manual position adjustments for states with complex geometry
      var positionOverrides = {
        'FL': {
          offsetX: 30,
          offsetY: -20
        },
        // Florida - move right 20px and up 20px
        'KY': {
          offsetX: 10,
          offsetY: 0
        },
        'HI': {
          offsetX: 150,
          offsetY: 80
        },
        // Hawaii - move down to avoid Alaska overlap
        'AK': {
          offsetX: 30,
          offsetY: 0
        },
        // Alaska - move right 30px
        'MI': {
          offsetX: 0,
          offsetY: -20
        },
        // Michigan - move up (lower peninsula)
        'LA': {
          offsetX: -19,
          offsetY: -10
        },
        'CA': {
          offsetX: -20,
          offsetY: 0
        },
        'ID': {
          offsetX: -10,
          offsetY: 25
        },
        'MN': {
          offsetX: -10,
          offsetY: 0
        },
        'VA': {
          offsetX: 10,
          offsetY: 0
        },
        'SC': {
          offsetX: 10,
          offsetY: -7
        }
      };
      states.forEach(function (state) {
        var stateCode = state.getAttribute('data-state');
        var bbox = state.getBBox();

        // Calculate center point with potential override
        var centerX = bbox.x + bbox.width / 2;
        var centerY = bbox.y + bbox.height / 2;

        // Apply manual adjustments if defined
        if (positionOverrides[stateCode]) {
          centerX += positionOverrides[stateCode].offsetX || 0;
          centerY += positionOverrides[stateCode].offsetY || 0;
        }

        // Create circle background (white fill, red stroke)
        var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        circle.setAttribute('cx', centerX);
        circle.setAttribute('cy', centerY);
        circle.setAttribute('r', '16'); // 16px radius = 32px diameter
        circle.setAttribute('fill', '#ffffff');
        circle.setAttribute('stroke', '#EB7B3C');
        circle.setAttribute('stroke-width', '1');
        circle.setAttribute('class', 'hl-state-label-circle');
        circle.setAttribute('pointer-events', 'none');
        circle.setAttribute('data-state', stateCode);

        // Create text element (dark blue)
        var text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        text.setAttribute('x', centerX);
        text.setAttribute('y', centerY);
        text.setAttribute('text-anchor', 'middle');
        text.setAttribute('dominant-baseline', 'middle');
        text.setAttribute('class', 'hl-state-label');
        text.setAttribute('pointer-events', 'none');
        text.setAttribute('fill', '#004371'); // All acronyms dark blue
        text.setAttribute('data-state', stateCode);
        text.textContent = stateCode;

        // Add circle first, then text (so text appears on top)
        labelsGroup.appendChild(circle);
        labelsGroup.appendChild(text);
      });
      svg.appendChild(labelsGroup);
    }

    /**
     * Add leader lines for small eastern states
     * Positions labels outside state boundaries with connecting lines
     */
  }, {
    key: "addLeaderLines",
    value: function addLeaderLines() {
      var svg = this.container.querySelector('svg');
      if (!svg) return;

      // Small states that need leader lines (eastern seaboard)
      var smallStates = ['NH', 'VT', 'MA', 'RI', 'CT', 'NJ', 'DE', 'MD', 'DC'];

      // Get SVG viewBox for positioning calculations
      var viewBox = svg.viewBox.baseVal;
      var svgWidth = viewBox.width;
      var svgHeight = viewBox.height;

      // Position labels to the right of the map, outside the coast
      var labelStartX = svgWidth + 50; // 50px outside the right edge
      var labelTopMargin = svgHeight * 0.15; // Start 15% from top
      var labelBottomMargin = svgHeight * 0.85; // End 85% from top
      var availableHeight = labelBottomMargin - labelTopMargin;
      var labelSpacing = availableHeight / (smallStates.length - 1); // Evenly distribute

      var linesGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      linesGroup.id = 'leader-lines';
      smallStates.forEach(function (stateCode, index) {
        var stateElement = svg.querySelector("path[data-state=\"".concat(stateCode, "\"]"));
        var labelCircle = svg.querySelector("circle[data-state=\"".concat(stateCode, "\"]"));
        var labelText = svg.querySelector("text.hl-state-label[data-state=\"".concat(stateCode, "\"]"));
        if (!stateElement || !labelCircle || !labelText) return;

        // Get state centroid
        var bbox = stateElement.getBBox();
        var stateCenterX = bbox.x + bbox.width / 2;
        var stateCenterY = bbox.y + bbox.height / 2;

        // Calculate new label position (right of map, evenly spaced vertically)
        var newLabelX = labelStartX;
        var newLabelY = labelTopMargin + labelSpacing * index;

        // Move circle and text to new position
        labelCircle.setAttribute('cx', newLabelX);
        labelCircle.setAttribute('cy', newLabelY);
        labelText.setAttribute('x', newLabelX);
        labelText.setAttribute('y', newLabelY);

        // Create leader line from state center to label
        var line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        line.setAttribute('x1', stateCenterX);
        line.setAttribute('y1', stateCenterY);
        line.setAttribute('x2', newLabelX - 20); // Stop 20px before circle edge
        line.setAttribute('y2', newLabelY);
        line.setAttribute('stroke', '#EB7B3C');
        line.setAttribute('stroke-width', '1.5');
        line.setAttribute('class', 'hl-state-leader-line');
        line.setAttribute('pointer-events', 'none');
        line.setAttribute('data-state', stateCode);

        // Add small dot at state end of line
        var dot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        dot.setAttribute('cx', stateCenterX);
        dot.setAttribute('cy', stateCenterY);
        dot.setAttribute('r', '3');
        dot.setAttribute('fill', '#EB7B3C');
        dot.setAttribute('class', 'hl-state-leader-dot');
        dot.setAttribute('pointer-events', 'none');
        dot.setAttribute('data-state', stateCode);
        linesGroup.appendChild(line);
        linesGroup.appendChild(dot);
      });

      // Insert lines group before labels so lines appear behind circles/text
      var labelsGroup = svg.querySelector('#state-labels');
      if (labelsGroup) {
        svg.insertBefore(linesGroup, labelsGroup);
      } else {
        svg.appendChild(linesGroup);
      }
    }

    /**
     * Apply colors to states from CPT data
     */
  }, {
    key: "applyColors",
    value: function applyColors() {
      var _this7 = this;
      var defaultColor = window.hlMapDefaultColor || '#CCCCCC';
      Object.entries(this.data).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          code = _ref2[0],
          data = _ref2[1];
        var stateElement = _this7.container.querySelector("[data-state=\"".concat(code, "\"]"));
        if (!stateElement) {
          return;
        }
        var color = data.color;

        // On a product-restricted map (e.g. EquitySelect), only color states that
        // actually offer at least one allowed product. States without any allowed
        // product fall back to the default "No license" color, even if a legend
        // color was set on them.
        if (_this7.allowedProducts) {
          var hasAllowedProduct = _this7.allowedProducts.some(function (key) {
            return data[key] === true;
          });
          if (!hasAllowedProduct) {
            color = defaultColor;
          }
        }
        if (color) {
          stateElement.style.fill = color;
        }
      });
    }

    /**
     * Attach event listeners to state elements and label circles
     */
  }, {
    key: "attachStateEvents",
    value: function attachStateEvents() {
      var _this8 = this;
      var states = this.container.querySelectorAll('path[data-state]');
      states.forEach(function (state) {
        // Click events
        state.addEventListener('click', function (e) {
          return _this8.handleStateClick(e);
        });

        // Keyboard accessibility
        state.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            _this8.handleStateClick(e);
          }
        });
      });

      // Also attach click events to all label circles
      var labelCircles = this.container.querySelectorAll('.hl-state-label-circle');
      labelCircles.forEach(function (circle) {
        circle.addEventListener('click', function (e) {
          return _this8.handleLabelClick(e);
        });
        circle.style.cursor = 'pointer';
        circle.setAttribute('pointer-events', 'auto');
      });
    }

    /**
     * Handle label circle click - trigger popup
     */
  }, {
    key: "handleLabelClick",
    value: function handleLabelClick(e) {
      e.stopPropagation();
      var stateCode = e.target.dataset.state;
      if (stateCode) {
        if (this.activeState === stateCode && this.isPopupPinned) {
          // Clicking same label closes popup
          this.closePopup();
        } else {
          this.showPopup(stateCode, true);
        }
      }
    }

    /**
     * Handle state click - pin popup
     */
  }, {
    key: "handleStateClick",
    value: function handleStateClick(e) {
      e.stopPropagation();
      var stateCode = e.target.dataset.state;
      if (this.activeState === stateCode && this.isPopupPinned) {
        // Clicking same state closes popup
        this.closePopup();
      } else {
        this.showPopup(stateCode, true);
      }
    }

    /**
     * Show popup with state data
     */
  }, {
    key: "showPopup",
    value: function showPopup(stateCode) {
      var pinned = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var stateData = this.data[stateCode];
      if (!stateData) {
        return;
      }
      this.activeState = stateCode;
      this.isPopupPinned = pinned;

      // Update popup content
      this.popup.querySelector('.hl-usa-map-popup-title').textContent = stateData.title;
      this.popup.querySelector('.hl-usa-map-popup-description').innerHTML = stateData.description;

      // Build services list
      var servicesList = this.popup.querySelector('.hl-usa-map-popup-services');
      servicesList.innerHTML = this.buildServicesList(stateData);

      // Show popup
      this.popup.style.display = 'block';
      this.popup.classList.toggle('pinned', pinned);

      // Apply mobile or desktop positioning
      if (this.isMobile) {
        this.showBottomSheet();
      } else {
        // Desktop: center popup
        this.popup.classList.add('hl-popup-desktop');
        this.popup.classList.remove('hl-popup-mobile', 'hl-popup-bottom-sheet');
        this.popup.style.position = 'absolute';
        this.popup.style.top = '50%';
        this.popup.style.left = '50%';
        this.popup.style.bottom = 'auto';
        this.popup.style.right = 'auto';
        this.popup.style.transform = 'translate(-50%, -50%)';
      }

      // Add active class to state
      this.container.querySelectorAll('[data-state]').forEach(function (s) {
        return s.classList.remove('active');
      });
      this.container.querySelector("[data-state=\"".concat(stateCode, "\"]")).classList.add('active');
    }

    /**
     * Build services checklist HTML
     */
  }, {
    key: "buildServicesList",
    value: function buildServicesList(stateData) {
      var _this9 = this;
      var services = [{
        key: 'es_1st_lien',
        label: 'EquitySelect 1st Lien'
      }, {
        key: 'es_2nd_lien',
        label: 'EquitySelect 2nd Lien'
      }, {
        key: 'es_purchase',
        label: 'EquitySelect Purchase'
      }, {
        key: 'reverse',
        label: 'Reverse'
      }, {
        key: 'platinum_fixed_rate',
        label: 'Elevate Fixed Rate'
      }, {
        key: 'platinum_loc',
        label: 'Elevate Line of Credit (LOC)'
      }, {
        key: 'equityfreedom_fixed',
        label: 'EquityFreedom Fixed'
      }, {
        key: 'equityfreedom_adjustable',
        label: 'EquityFreedom Adjustable'
      }];

      // Limit to a product subset when the map specifies one (e.g. EquitySelect map).
      if (this.allowedProducts) {
        services = services.filter(function (service) {
          return _this9.allowedProducts.includes(service.key);
        });
      }
      return services.map(function (service) {
        var isAvailable = stateData[service.key];
        var icon = isAvailable ? '<span class="service-icon service-available">✓</span>' : '<span class="service-icon service-unavailable">✗</span>';
        var className = isAvailable ? 'available' : 'unavailable';
        return "<li class=\"service-item ".concat(className, "\">").concat(icon, " ").concat(service.label, "</li>");
      }).join('');
    }

    /**
     * Close popup
     */
  }, {
    key: "closePopup",
    value: function closePopup() {
      this.popup.style.display = 'none';
      this.isPopupPinned = false;
      this.activeState = null;

      // Clean up mobile-specific classes and styles
      this.popup.classList.remove('hl-popup-mobile', 'hl-popup-bottom-sheet', 'hl-popup-desktop');
      this.popup.style.transform = '';
      this.popup.style.transition = '';

      // Remove active class from all states
      this.container.querySelectorAll('[data-state]').forEach(function (s) {
        return s.classList.remove('active');
      });
    }

    /**
     * Attach popup control events
     */
  }, {
    key: "attachPopupEvents",
    value: function attachPopupEvents() {
      var _this0 = this;
      if (!this.popup) {
        return;
      }

      // Close button
      var closeBtn = this.popup.querySelector('.hl-usa-map-popup-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          return _this0.closePopup();
        });
      }

      // Click outside to close
      document.addEventListener('click', function (e) {
        if (_this0.isPopupPinned && !_this0.popup.contains(e.target) && !_this0.container.contains(e.target)) {
          _this0.closePopup();
        }
      });

      // ESC key to close
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && _this0.isPopupPinned) {
          _this0.closePopup();
        }
      });
    }

    /**
     * Initialize state search controls
     */
  }, {
    key: "initSearchControls",
    value: function initSearchControls() {
      var _this1 = this;
      var searchInput = document.getElementById('hl-state-search');
      var searchResults = document.getElementById('hl-search-results');
      if (!searchInput || !searchResults) {
        return;
      }
      var debounceTimeout;
      searchInput.addEventListener('input', function (e) {
        clearTimeout(debounceTimeout);
        var query = e.target.value.trim().toLowerCase();
        if (query.length === 0) {
          searchResults.style.display = 'none';
          searchResults.innerHTML = '';
          return;
        }
        debounceTimeout = setTimeout(function () {
          _this1.performSearch(query, searchResults);
        }, 300);
      });

      // Close results when clicking outside
      document.addEventListener('click', function (e) {
        if (!searchInput.contains(e.target) && !searchResults.contains(e.target)) {
          searchResults.style.display = 'none';
        }
      });
    }

    /**
     * Perform state search
     */
  }, {
    key: "performSearch",
    value: function performSearch(query, resultsContainer) {
      var _this10 = this;
      var matches = [];
      Object.entries(this.data).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          code = _ref4[0],
          data = _ref4[1];
        var stateName = data.title.toLowerCase();
        var stateCode = code.toLowerCase();
        if (stateName.includes(query) || stateCode.includes(query)) {
          matches.push({
            code: code,
            title: data.title
          });
        }
      });
      if (matches.length === 0) {
        resultsContainer.innerHTML = '<div class="hl-search-no-results">No states found</div>';
        resultsContainer.style.display = 'block';
        return;
      }
      var html = matches.map(function (match) {
        return "<div class=\"hl-search-result-item\" data-state=\"".concat(match.code, "\">\n\t\t\t\t<strong>").concat(match.code, "</strong> - ").concat(match.title, "\n\t\t\t</div>");
      }).join('');
      resultsContainer.innerHTML = html;
      resultsContainer.style.display = 'block';

      // Attach click handlers to results
      resultsContainer.querySelectorAll('.hl-search-result-item').forEach(function (item) {
        item.addEventListener('click', function (e) {
          var stateCode = e.currentTarget.dataset.state;
          _this10.zoomToState(stateCode);
          _this10.showPopup(stateCode, true);
          resultsContainer.style.display = 'none';
          document.getElementById('hl-state-search').value = '';
        });
      });
    }

    /**
     * Zoom to a specific state
     */
  }, {
    key: "zoomToState",
    value: function zoomToState(stateCode) {
      var stateElement = this.container.querySelector("[data-state=\"".concat(stateCode, "\"]"));
      if (!stateElement || !this.panZoomInstance) {
        return;
      }
      var bbox = stateElement.getBBox();
      var svgElement = this.container.querySelector('svg');
      var viewBox = svgElement.viewBox.baseVal;

      // Calculate center point
      var centerX = bbox.x + bbox.width / 2;
      var centerY = bbox.y + bbox.height / 2;

      // Calculate zoom level based on state size
      var zoomLevel = Math.min(viewBox.width / (bbox.width * 1.5), viewBox.height / (bbox.height * 1.5), 10);

      // Pan to center
      this.panZoomInstance.zoom(zoomLevel);
      this.panZoomInstance.pan({
        x: -centerX * zoomLevel + viewBox.width / 2,
        y: -centerY * zoomLevel + viewBox.height / 2
      });

      // Highlight state
      this.container.querySelectorAll('[data-state]').forEach(function (s) {
        return s.classList.remove('active');
      });
      stateElement.classList.add('active');
    }

    /**
     * Initialize service filtering
     */
  }, {
    key: "initServiceFilters",
    value: function initServiceFilters() {
      var _this11 = this;
      var filterCheckboxes = document.querySelectorAll('.hl-filter-checkboxes input[type="checkbox"]');
      var filterToggle = document.querySelector('.hl-filter-toggle');
      var clearFilters = document.querySelector('.hl-clear-filters');
      var filterCount = document.querySelector('.hl-filter-count');
      if (!filterCheckboxes.length) {
        return;
      }

      // Checkbox change handler
      filterCheckboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
          _this11.updateActiveFilters();
          _this11.applyServiceFilters();
          _this11.updateFilterCount(filterCount);
        });
      });

      // Toggle AND/OR mode
      if (filterToggle) {
        filterToggle.addEventListener('click', function () {
          _this11.filterMode = _this11.filterMode === 'and' ? 'or' : 'and';
          filterToggle.textContent = "Match: ".concat(_this11.filterMode.toUpperCase());
          filterToggle.dataset.mode = _this11.filterMode;
          _this11.applyServiceFilters();
        });
      }

      // Clear all filters
      if (clearFilters) {
        clearFilters.addEventListener('click', function () {
          filterCheckboxes.forEach(function (cb) {
            return cb.checked = false;
          });
          _this11.activeFilters = [];
          _this11.applyServiceFilters();
          _this11.updateFilterCount(filterCount);
        });
      }
    }

    /**
     * Update active filters array
     */
  }, {
    key: "updateActiveFilters",
    value: function updateActiveFilters() {
      var filterCheckboxes = document.querySelectorAll('.hl-filter-checkboxes input[type="checkbox"]:checked');
      this.activeFilters = Array.from(filterCheckboxes).map(function (cb) {
        return cb.value;
      });
    }

    /**
     * Apply service filters to states
     */
  }, {
    key: "applyServiceFilters",
    value: function applyServiceFilters() {
      var _this12 = this;
      var states = this.container.querySelectorAll('[data-state]');
      if (this.activeFilters.length === 0) {
        // No filters - show all states
        states.forEach(function (state) {
          return state.classList.remove('hl-state-dimmed');
        });
        return;
      }
      states.forEach(function (state) {
        var stateCode = state.dataset.state;
        var stateData = _this12.data[stateCode];
        if (!stateData) {
          return;
        }
        var matches = false;
        if (_this12.filterMode === 'and') {
          // ALL filters must match
          matches = _this12.activeFilters.every(function (filter) {
            return stateData[filter] === true;
          });
        } else {
          // ANY filter must match
          matches = _this12.activeFilters.some(function (filter) {
            return stateData[filter] === true;
          });
        }
        state.classList.toggle('hl-state-dimmed', !matches);
      });
    }

    /**
     * Update filter count display
     */
  }, {
    key: "updateFilterCount",
    value: function updateFilterCount(countElement) {
      if (!countElement) {
        return;
      }
      var visibleStates = this.container.querySelectorAll('[data-state]:not(.hl-state-dimmed)').length;
      var totalStates = Object.keys(this.data).length;
      if (this.activeFilters.length === 0) {
        countElement.textContent = '';
      } else {
        countElement.textContent = "Showing ".concat(visibleStates, " of ").concat(totalStates, " states");
      }
    }

    /**
     * Initialize legend toggle
     */
  }, {
    key: "initLegendToggle",
    value: function initLegendToggle() {
      var legendToggle = document.querySelector('.hl-legend-toggle');
      var legendContent = document.querySelector('.hl-legend-content');
      if (!legendToggle || !legendContent) {
        return;
      }
      legendToggle.addEventListener('click', function () {
        var isExpanded = legendToggle.getAttribute('aria-expanded') === 'true';
        var newState = !isExpanded;
        legendToggle.setAttribute('aria-expanded', newState);
        legendContent.style.display = newState ? 'block' : 'none';
        legendToggle.querySelector('.hl-legend-icon').textContent = newState ? '−' : '+';
      });
    }
  }]);
}(); // Initialize map when DOM is ready
var _default = exports["default"] = USAInteractiveMap;

},{}],2:[function(require,module,exports){
"use strict";

var _usaMap = _interopRequireDefault(require("./modules/usa-map"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// Initialize USA map when DOM is ready
document.addEventListener('DOMContentLoaded', function () {
  if (document.getElementById('hl-usa-map')) {
    new _usaMap["default"]();
  }
});

},{"./modules/usa-map":1}]},{},[2]);
